export default __webpack_public_path__ + "static/media/Update-Address.547d6988.jpg";